
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'
import Cell from 'vux/src/components/cell/index.vue'

import WxHeader from './Header'
import WxFooter from './Footer'

export default {
data(){
return{
ishow:false,
post:{
address : ''
}
}
},
components: {
XTextarea,
Group,
XInput,
XButton,
WxHeader,
WxFooter,
Alert,
AlertModule,
Cell
},
created(){

},
methods: {
onEvent (event) {
console.log('on', event)
},
init(){
},
submit(){
let _self = this;

let api_url = this.server_api_url+'service=save_houses';
var formData = _self.post;
let login_data = this.get_login_session_data();
let access_token = this.get_access_token();
if(login_data && access_token){
formData.openid = login_data.openid;
formData.member_id = login_data.member_id;
formData.YZICode_cur = login_data.YZICode_cur;
}else{
return false;
}

if(this.post.address.length <= 1){
_self.baseShowModule('房号至少2个字','提交失败');
return false;
}
formData = this.qs.stringify(formData);
this.$axios({
method:'post',
url:api_url,
headers: {'token': access_token},
data:formData,

}).then((response) =>{
let data_arr = response.data;
_self.check_token_data_status(data_arr);
if(data_arr.status == '1'){
_self.baseShowModuleAuto(data_arr.msg,'提交成功',2000,'/HouseMy');
_self.post.address = '';
}else{
_self.baseShowModule(data_arr.msg,'提交失败');
}
}).catch((response) =>{
console.log(response)
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/HouseAdd.vue